import { Component, OnInit } from '@angular/core';
import { ContentModel } from 'src/app/services/contents/models/content.model';
import { ContentTypeEnum } from '../../shared/enums/content-type.enum';
import { PetTypeEnum } from '../../shared/enums/pet-type.enum';
import { ContentsService } from 'src/app/services/contents/contents-service';
import { ActivatedRoute, Router } from '@angular/router';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-generic-contents-screen',
  templateUrl: './generic-contents-screen.component.html',
  styleUrl: './generic-contents-screen.component.scss'
})
export class GenericContentsScreenComponent implements OnInit {
  documents: ContentModel[] = [];
  isMobile: boolean;
  innerWidth: number;
  pageNumber = 0;
  itensPerPage = 12;
  type: ContentTypeEnum;
  pageTitle: string;
  PetTypeEnum = PetTypeEnum;
  totalDocuments: number;
  totalPages: number;
  isVideosAndEventsScreen = false;

  constructor(
    private contentsService: ContentsService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        map((params) => params.get('type') as ContentTypeEnum),
        distinctUntilChanged()
      )
      .subscribe((type) => {
        this.isVideosAndEventsScreen =
          type === ContentTypeEnum.VIDEOS_AND_EVENTS;
        this.type = type;
        this.pageNumber = 0;
        this.documents = [];
        this.getInformative();
      });
    this.innerWidth = window.innerWidth;
    this.isMobile = this.innerWidth <= 900;
    if (this.isMobile) {
      //this.itensPerPage = 999;
      this.pageNumber = 1;
    }
  }

  getInformative(): void {
    if (this.isVideosAndEventsScreen) return;

    const typeMap: Record<ContentTypeEnum, number> = {
      [ContentTypeEnum.TECHNICAL_INFORMATIVES]: 1,
      [ContentTypeEnum.SUPPORT_MATERIALS]: 2,
      [ContentTypeEnum.VIDEOS_AND_EVENTS]: 3
    };

    const mappedType = typeMap[this.type];

    this.contentsService
      .getDocuments(this.pageNumber, this.itensPerPage, mappedType)
      .subscribe((res) => {
        if (this.isMobile) {
          this.documents = [...this.documents, ...res.items];
        } else {
          this.documents = res.items;
        }
        this.totalPages = res.totalPages;
        this.totalDocuments = res.totalCount;
      });
  }

  onPageChange(newPage: number): void {
    this.pageNumber = newPage;
    if (this.pageNumber < 0) {
      this.pageNumber = 0;
    }

    this.getInformative();
  }

  onScroll(): void {
    this.pageNumber++;
    if (this.pageNumber > this.totalPages) return;
    this.getInformative();
  }

  downloadPdf(content: ContentModel) {
    this.contentsService.downloadPdf(content.title, content.documentUrl);
  }

  clickInfor(content: ContentModel): void {
    this.contentsService.updateData(content);
    this.router.navigate([`${this.type}-read`, content.id], {
      relativeTo: this.route
    });
  }
}
